import React, { ChangeEvent, useContext } from "react";
import { Button } from "@cmsgov/ds-medicare-gov";
import { useTranslate } from "../../helpers";
import { AppStore } from "../../app/store";
import { getRegistrationUrl } from "../../helpers/loginHelpers";
import {
  AnalyticsActionType,
  AnalyticsButton,
  AnalyticsButtonStyle,
  AnalyticsButtonType,
} from "../../app/contexts/Analytics/types";

interface LoginFormProps {
  onClickLogin: (analyticsButton: AnalyticsButton) => void;
}

export const LoginForm: React.FunctionComponent<LoginFormProps> = props => {
  const t = useTranslate();
  const {
    state: { language },
    dispatch,
  } = useContext(AppStore.AppContext);

  const createAccountUrl = getRegistrationUrl(language);
  const createAccountLinkText = t("landing_page.login_form.create_one");

  const loginText = t("landing_page.login_form.log_in");

  const analyticsButton = {
    text: loginText,
    buttonStyle: AnalyticsButtonStyle.PRIMARY,
    buttonType: AnalyticsButtonType.SUBMIT,
  };

  const onClickLogin = (e: ChangeEvent<HTMLFormElement>): void => {
    e.preventDefault();
    props.onClickLogin(analyticsButton);
  };

  return (
    <div className="mct-c-login-form">
      <form onSubmit={onClickLogin}>
        <p className="mct-c-login-form__heading">
          {t("landing_page.login_form.heading")}
        </p>
        <ul>
          <li>{t("landing_page.login_form.get_a_summary")}</li>
          <li>{t("landing_page.login_form.use_saved_drugs")}</li>
        </ul>
        <Button
          variation="solid"
          className="mct-c-login-form__login-button"
          type="submit"
          data-cy="e2e-landing-login"
        >
          {loginText}
        </Button>
        <p className="ds-u-margin-bottom--0">
          {t("landing_page.login_form.dont_have_account")}{" "}
          <a
            href={createAccountUrl}
            onClick={() => {
              dispatch({
                type: AnalyticsActionType.SEND_INTERNAL_LINK_CLICKED_EVENT,
                settings: {
                  linkText: createAccountLinkText,
                  linkUrl: createAccountUrl,
                },
              });
            }}
          >
            {createAccountLinkText}
          </a>
        </p>
      </form>
    </div>
  );
};
